module.exports = __webpack_public_path__ + "img/cry.89f6558c.gif";